export default __webpack_public_path__ + "static/media/Bullets Icon.9e03c038.svg";